import { crudRequest } from '@/services/api';
import moment from 'moment';
import { computeWeightNotAbs, computeWeights } from '@/utils/query';
import { isArray } from 'lodash';

export default {
  namespace: 'loadnosendmodalsTest22',
  state: {
    modalsVisible: false,
    modalsTitle: '',
    modalsNextSite: '',
    rowData: null, // 弹窗行信息
    productCalcWeightList: [],
    productTicketList: [],
    lineChartData: [],
  },

  effects: {
    // 已装未发
    *queryLoadNoSendDetail({ payload }, { call, select, put }) {
      yield put({ type: 'updateState', payload });

      const { taskNos, originCenterCode, destinationCenterCode } = payload;

      const centerWeightViewTest = yield select(({ centerWeightViewTest }) => centerWeightViewTest);
      const { dateRange, defualtDateFormat } = centerWeightViewTest;
      const [startDate, endDate] = dateRange.map(
        date => date && moment(date).format(defualtDateFormat),
      );

      const response = yield call(crudRequest, '/api/route/selectSrLoadNoSendDetail', {
        taskNos,
        originCenterCode,
        destinationCenterCode,
        queryType: 30,
        startDate,
        endDate,
      });

      yield put({
        type: 'updateState',
        payload: {
          lineChartData: response?.data,
          loadNoSendDetailExportVos: isArray(response?.data?.loadNoSendDetailExportVos)
            ? response?.data?.loadNoSendDetailExportVos
            : [],
        },
      });
      return response;
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
